import { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useSearchParams } from "react-router-dom";
import { Header } from "./components/Header";
import { CalendarPage } from "./pages/CalendarPage";
import { AdminPage } from "./pages/AdminPage";
import { EmbedCalendar } from "./components/EmbedCalendar";
import { Toaster } from "./components/ui/sonner";

// Embed wrapper to detect embed mode
const EmbedWrapper = () => {
  const [searchParams] = useSearchParams();
  const isEmbed = searchParams.get('embed') === 'true';
  
  if (isEmbed) {
    return <EmbedCalendar />;
  }
  
  return null;
};

function App() {
  const [isInternational, setIsInternational] = useState(false);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Embed route - no header */}
          <Route path="/embed" element={<EmbedCalendar />} />
          
          {/* Normal routes with header */}
          <Route path="/*" element={
            <>
              <Header 
                isInternational={isInternational} 
                setIsInternational={setIsInternational} 
              />
              <Routes>
                <Route 
                  path="/" 
                  element={<CalendarPage isInternational={isInternational} />} 
                />
                <Route path="/admin" element={<AdminPage />} />
              </Routes>
            </>
          } />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
